import * as yup from 'yup';


import * as i18nUtils from '../../../../utils/i18nUtils';

import {contactFormConstants} from '../../Contact/ContactForm';
import {emailConfirmationFormConstants} from '../../Email/EmailConfirmationForm';
import {passwordConfirmationFormConstants} from '../PasswordConfirmationForm';
import {languageSelectFormConstants} from '../../I18n/LanguageSelectForm';


export const SCHEMA_USER_FORM = yup.object()
    .shape({
        isNewsletterRecipient: yup.bool()
            .nullable()
            .required()
            .default(false),
        locale: languageSelectFormConstants.SCHEMA_PLATFORM_LANGUAGE
            .default(i18nUtils.detectBrowserLocaleTag()),
        name: contactFormConstants.SCHEMA_NAME,
        surname: contactFormConstants.SCHEMA_SURNAME
    })
    .concat(emailConfirmationFormConstants.SCHEMA_EMAIL_CONFIRMATION_FORM)
    .concat(passwordConfirmationFormConstants.SCHEMA_PASSWORD_CONFIRMATION_FORM)
;
